import { Eye } from "lucide-react";
import { getImpersonation, stopImpersonation } from "../../features/admin/impersonation";

/** Sticky banner shown while a super-admin is impersonating another user. */
export default function ImpersonationBanner() {
  const marker = getImpersonation();
  if (!marker) return null;
  return (
    <div className="flex items-center justify-center gap-3 bg-ink-900 px-4 py-1.5 text-[12.5px] text-white">
      <Eye size={14} className="text-gold-400" />
      <span>
        Viewing as <span className="font-semibold">{marker.name}</span> ({marker.email})
      </span>
      <button
        onClick={stopImpersonation}
        className="rounded-md bg-white/15 px-2.5 py-1 text-[11.5px] font-semibold hover:bg-white/25"
      >
        Return to admin
      </button>
    </div>
  );
}
